<script>
import Constants from '../constants';

import moveTextHover from '@/components/moveTextHover';

import {imagesLoad} from '@/util/assetLoadUtil';
import bandLogoSquare from '@/assets/img/common/bandLogoSquare_w.svg';
import twitterIcon from '@/assets/img/sns/twitter.svg';
import youTubeIcon from '@/assets/img/sns/youTube.svg';
import instagramIcon from '@/assets/img/sns/instagram.svg';
import spotifyIcon from '@/assets/img/sns/spotify.svg';
// import threadsIcon from '@/assets/img/sns/threadsWhite.svg';
import blueskyIcon from '@/assets/img/sns/bluesky.svg';

export default {
  name: 'commonNav',
  components: {
    moveTextHover
  },
  props: {
    isShowLogo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShowMenu: false, // pcには関係なし
      isShowStreaming: false,
      ready: false,
      count: 0,
      windowHeight: Constants.WINDOW.MIN_HEIGHT.viewSm,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.ready = false;
      imagesLoad([
        bandLogoSquare,
        twitterIcon,
        youTubeIcon,
        instagramIcon,
        spotifyIcon,
        // threadsIcon,
        blueskyIcon,
      ]);
      setTimeout(()=> {
        this.ready = true;
      }, 1);
      window.onresize = () => { this.onresize(); }
      this.onresize();
    },
    moveToIndex() {
      if (this.$router.currentRoute.name !== Constants.ROUTER.INDEX) {
        this.$router.push({
          name: Constants.ROUTER.INDEX,
        });
      } else {
        this.scrollToTop();
      }
    },
    moveToInformation() {
      if (this.$router.currentRoute.name !== Constants.ROUTER.INDEX) {
        this.$router.push({
          name: Constants.ROUTER.INDEX,
          query: {
            isInformation: 1,
          },
        });
      } else {
        this.scrollToTop(this.windowHeight);
      }
    },
    moveToBiography() {
      if (this.$router.currentRoute.name !== Constants.ROUTER.BIOGRAPHY) {
        this.$router.push({ name: Constants.ROUTER.BIOGRAPHY });
      } else {
        this.scrollToTop();
      }
    },
    moveToDiscography() {
      if (this.$router.currentRoute.name !== Constants.ROUTER.DISCOGRAPHY) {
        this.$router.push({ name: Constants.ROUTER.DISCOGRAPHY });
      } else {
        this.scrollToTop();
      }
    },
    scrollToTop(scroll = 0) {
      window.scroll({
        top: scroll ,
        left: 0 ,
        behavior: "smooth" ,
      });
    },
    toggleMenu() {
      this.isShowMenu = !this.isShowMenu;
    },

    openTwitter() { window.open(Constants.SNS.TWITTER, '_blank'); },
    openYoutube() { window.open(Constants.SNS.YOUTUBE, '_blank'); },
    openInstagram() { window.open(Constants.SNS.INSTAGRAM, '_blank'); },
    openTikTok() { window.open(Constants.SNS.TIKTOK, '_blank'); },
    // openThreads() { window.open(Constants.SNS.THREADS, '_blank'); },
    // openBluesky() { window.open(Constants.SNS.BLUESKY, '_blank'); },

    moveToStreaming() {
      if (this.$router.currentRoute.name !== Constants.ROUTER.DISTRIBUTION) {
        this.$router.push({ name: Constants.ROUTER.DISTRIBUTION });
      } else {
        this.scrollToTop();
      }
    },

    onresize() {
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      this.windowHeight = window.innerHeight < minHeight ? minHeight : window.innerHeight;
    },
  },
};
</script>

<template>
  <nav class="common-nav wf-gothicfont" :class="[isShowMenu ? 'is-show' : '', $mq]" v-if='ready'>

    <div class="hamburger" @click="toggleMenu"
      :title="isShowMenu ? $t('message.common.close') : $t('message.common.menu')"
    ></div>

    <div class="logoContainer" v-if="isShowLogo">
      <div class="logo" @click="moveToIndex" :title="$t('message.information.pageName')"></div>
    </div>

    <div class="is-link" @click="moveToInformation">
      <move-text-hover :target-text="$t('message.information.pageName')" />
    </div>
    <div class="is-link" @click="moveToDiscography">
      <move-text-hover :target-text="$t('message.discography.pageName')" />
    </div>
    <div class="is-link" @click="moveToBiography">
      <move-text-hover :target-text="$t('message.biography.pageName')" />
    </div>

    <div class="sns-container">
      <div class="is-sns-link twitter" @click="openTwitter" :title="$t('message.snsName.twitter')"></div>
      <div class="is-sns-link instagram" @click="openInstagram" :title="$t('message.snsName.instagram')"></div>
      <!-- <div class="is-sns-link bluesky" @click="openBluesky" :title="$t('message.snsName.bluesky')"></div> -->
      <div class="is-sns-link youTube" @click="openYoutube" :title="$t('message.snsName.youTube')"></div>
      <div class="is-sns-link tikTok" @click="openTikTok" :title="$t('message.snsName.tikTok')"></div>
      <!-- <div class="is-sns-link threads" @click="openThreads" :title="$t('message.snsName.threads')"></div> -->
      <div class="is-sns-link spotify" @click="moveToStreaming" :title="$t('message.distribution.pageName')"></div>
    </div>
  </nav>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .common-nav {
    z-index: $zIndexCommonNav;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: $commonNavHeight;
    display: flex;
    justify-content: space-around;
    background: $bgColorA50;
    color: $textColor;

    .is-link {
      transition: 1s linear;
      :hover {
        color: $accentColor2;
      }
    }
    .sns-container {
      position: absolute;
      top: 10px;
      left: 140px;
      width: 200px;
      height: 30px;
      display: flex;
      justify-content: space-between;
      .is-sns-link {
        width: 30px;
        height: 30px;
        cursor: pointer;
        @include bgCenter;
        transform: scale(1);
        transition: 0.1s ease-out;
        &.twitter {background-image: url(../assets/img/sns/twitter.svg);}
        &.instagram {background-image: url(../assets/img/sns/instagram.svg);}
        &.youTube {background-image: url(../assets/img/sns/youTube.svg);}
        &.spotify {background-image: url(../assets/img/sns/spotify.svg);}
        &.tikTok {background-image: url(../assets/img/sns/tiktokWhite.svg);}
        // &.threads {background-image: url(../assets/img/sns/threadsWhite.svg);}
        // &.bluesky {background-image: url(../assets/img/sns/bluesky.svg);}
        &:hover {
          transform: scale(1.2) rotate(10deg) ;
        }
        &.is-hidden {
          display: none;
        }
      }
    }
    
  
    .logoContainer {
      position: relative;
      .logo {
        position: absolute;
        width: 100px;
        height: 100px;
        @include bgCenter;
        background-image: url(../assets/img/common/bandLogoSquare_w.svg);
        cursor: pointer;
        transition: 0.1s ease-out;
        &:hover {
          transform: scale(1.1);
        }
      }
    }

    .hamburger {
      width: $commonNavHeight;
      height: $commonNavHeight;
      position: fixed;
      top: 0;
      left: 0;
      cursor: pointer;
      @include bgCenter;
      background-image: url(../assets/img/common/btnHamburger.svg);
    }
    &.is-show {
      .hamburger {
        background-image: url(../assets/img/common/btnClose.svg);
      }
    }

    
    // responsible -----------------------------------------------
    &.viewLg {
      font-size: 2em;

      .hamburger {display: none;}
      .is-link {
        margin: 0 20px;
      }
      .logoContainer {
        flex: 1;
        .logo {
          margin-left: 30px;
        }
      }
    }
    &.viewMd {
      font-size: 3em;
    }
    &.viewSm {
      font-size: 2em;
    }

    &.viewMd, &.viewSm {
      right: auto;
      width: $commonNavHeight;
      flex-flow: column;
      justify-content: space-around;
      .logoContainer {
        display: none;
        height: 100px;
        left: 50%;
        margin-left: -50px;
      }

      .is-link {
        display: none;
        text-align: center;
      }

      .sns-container {
        display: none;
      }
      
      &.is-show {
        width: auto;
        height: auto;
        right: 0;
        bottom: 0;
        .logoContainer { display: block; }
        .is-link { display: block; }
        .sns-container {
          display: block;
          left: 50px;
          right: 0px;
          width: auto;
          height: 40px;
          display: flex;
          justify-content: space-around;
          .is-sns-link {
            width: 40px;
            height: 40px;
            cursor: pointer;
          }
          .streaming-buttons {
            .is-sns-link {
              margin-bottom: 30px;
            }
          }
        }
      }
    }
  }
</style>
